module.exports = __webpack_public_path__ + "img/zoomout.cf1135fb.png";